import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Media } from "../../../js/parsegenerated";
import { SelectMedia } from "./SelectMedia";

type Props = {
  value?: Media[];
  onChange?: (value: Media[]) => void;
};

export const MediaInput = observer((props: Props) => {
  const [files, setFiles] = React.useState<Parse.File[]>([]);

  function handleSetFiles(files: Parse.File[]) {
    setFiles(files);
    props.onChange?.(files?.map((file) => new Media({ media: file })));
  }

  useEffect(() => {
    setFiles(props.value?.map((media) => media.get("media")) ?? []);
  }, [props.value]);

  return <SelectMedia parseFiles={files} setParseFiles={handleSetFiles} />;
});
